import _ from "lodash";
import moment from "moment";
import { $constants } from "@/scripts/constants";
import i18n from "@/locales/i18n";
import html2canvas from "html2canvas";

export function byteToKb(byteSize: number) {
    return Math.round(byteSize / 1024);
}

export function enumI18nFormat(enumName: string, enumKey: string, prefix = "common") {
    return enumKey ? i18n.t(`${prefix}.${enumName}.${enumKey}`) : "";
}

export function enumClassName(enumKey: string, prefix = "TAG") {
    return enumKey ? i18n.t(`${prefix}_${enumKey}`) : "";
}

export function emptyValue(value: string | null | undefined, defaultI18nKey = "common.noContent") {
    return value && !_.isEmpty(value) ? value : i18n.t(defaultI18nKey);
}

export function moneyFormat(fee: number) {
    return "￥" + fee.toFixed(2);
}

export function getCentAmount(amount: number) {
    const multipliedValue = amount * 100;
    return Number(multipliedValue.toFixed(0));
}

export function datetimeFormat(value: any, format: string = $constants.DATETIME_FMT) {
    return value ? moment(value).format(format) : value;
}

export async function html2imgDataUrl(html) {
    let canvasBox = document.getElementById(`canvas-box`);
    if (!canvasBox) {
        const canvasTmpBox = document.createElement("div");
        canvasTmpBox.style.position = "relative";
        canvasTmpBox.style.overflow = "hidden";
        canvasBox = document.createElement("div");
        canvasBox.id = "canvas-box";
        canvasBox.style.position = "absolute";
        canvasTmpBox.append(canvasBox);
        document.getElementsByTagName("body")[0].append(canvasTmpBox);
    }
    canvasBox.innerHTML = html;
    const canvas = await html2canvas(canvasBox, {
        scale: window.devicePixelRatio * 2,
        allowTaint: true,
        useCORS: true,
        scrollX: -window.scrollX,
        scrollY: -window.scrollY
    });
    return canvas.toDataURL();
}
